import { Store } from '@reduxjs/toolkit';
import { FC } from 'react';
import { Provider } from 'react-redux';

export const ReduxProvider: FC<{ store: Store }> = ({ children, store }) => (
  <Provider store={store}>{children}</Provider>
);
